import { AdminShell } from "@/components/Layout";
import OfficeAIHelpPanel from "@/components/OfficeAIHelp";
import { Robot } from "@phosphor-icons/react";

export default function OfficeAIHelpPage() {
  return (
    <AdminShell>
      <div className="max-w-5xl mx-auto p-4 space-y-4">
        <div>
          <div className="text-[10px] font-black uppercase tracking-widest text-fuchsia-700 flex items-center gap-1">
            <Robot weight="fill" size={12}/> Office AI Help
          </div>
          <h1 className="font-display font-black text-3xl mt-1">Ask anything · shared team knowledge</h1>
          <p className="mt-1 text-sm text-slate-600 max-w-xl">
            Describe an issue, attach a photo, get instant diagnostic help. Every thread is visible to your whole office team so tech questions build up into a searchable knowledge base.
          </p>
        </div>
        <div className="h-[70vh] border-2 border-slate-900 shadow-lg" data-testid="office-ai-help-page">
          <OfficeAIHelpPanel embedded/>
        </div>
      </div>
    </AdminShell>
  );
}
